"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import * as React from "react";
type ScrollAreaProps = React.ComponentProps<typeof ScrollAreaPrimitive.Root> & {
  scrollbarOrientation?: "vertical" | "horizontal" | "both";
};
function ScrollArea(t0) {
  const $ = _c(20);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      scrollbarOrientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const scrollbarOrientation = t1 === undefined ? "vertical" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("relative", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children) {
    t3 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" className="focus-visible:ring-ring/50 rounded-inherit size-full outline-none transition-[color,box-shadow] focus-visible:outline-1 focus-visible:ring-[3px]">{children}</ScrollAreaPrimitive.Viewport>;
    $[7] = children;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== scrollbarOrientation) {
    t4 = (scrollbarOrientation === "vertical" || scrollbarOrientation === "both") && <ScrollBar />;
    $[9] = scrollbarOrientation;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== scrollbarOrientation) {
    t5 = (scrollbarOrientation === "horizontal" || scrollbarOrientation === "both") && <><ScrollBar orientation="horizontal" /></>;
    $[11] = scrollbarOrientation;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ScrollAreaPrimitive.Corner />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t7 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t2} {...props}>{t3}{t4}{t5}{t6}</ScrollAreaPrimitive.Root>;
    $[14] = props;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function ScrollBar(t0) {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const t2 = orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent";
  const t3 = orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent";
  let t4;
  if ($[4] !== className || $[5] !== t2 || $[6] !== t3) {
    t4 = cn("flex touch-none select-none p-px transition-colors", t2, t3, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollAreaPrimitive.ScrollAreaThumb data-slot="scroll-area-thumb" className="bg-border relative flex-1 rounded-full" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== orientation || $[10] !== props || $[11] !== t4) {
    t6 = <ScrollAreaPrimitive.ScrollAreaScrollbar data-slot="scroll-area-scrollbar" orientation={orientation} className={t4} {...props}>{t5}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[9] = orientation;
    $[10] = props;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export { ScrollArea, ScrollBar };